export const DEFAULT_PASTE_ALLOWED_TAGS = [
  'ul',
  'ol',
  'li',
  'b',
  'strong',
  'i',
  'em',
  'u',
  'p',
  'br',
  'a',
];

const unwrap = element => {
  const fragment = document.createDocumentFragment();
  while (element.firstChild) {
    fragment.appendChild(element.firstChild);
  }
  element.parentNode.replaceChild(fragment, element);
};

/**
 * TinyMCE paste_postprocess that strips pasted markup down to allowedTags.
 *
 * @param {object} [options]
 * @param {string[]} [options.allowedTags]
 * @param {(src: string) => boolean} [options.isImgSrcAllowed] Only consulted
 *   when 'img' is allowed; an <img> whose src fails is removed outright rather
 *   than unwrapped, since it has no text to keep. Evaluated at paste time so
 *   callers can read async state (e.g. the upload bucket) from a ref.
 * @param {string} [options.imgStyle] Inline style forced onto kept images.
 */
export const createPasteProcessor = (options = {}) => {
  const {
    allowedTags = DEFAULT_PASTE_ALLOWED_TAGS,
    isImgSrcAllowed = () => false,
    imgStyle,
  } = options;

  return (_, args) => {
    const allElements = args.node.querySelectorAll('*');
    allElements.forEach(element => {
      const tag = element.tagName.toLowerCase();
      if (!allowedTags.includes(tag)) {
        unwrap(element);
        return;
      }
      if (tag !== 'img') return;

      if (!isImgSrcAllowed(element.getAttribute('src'))) {
        element.remove();
        return;
      }
      if (imgStyle) element.setAttribute('style', imgStyle);
    });
  };
};
